module.exports = __webpack_public_path__ + "img/card-bg-bvic.0f40d774.png";